var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 4 7", fill: "none" }, props),
    React.createElement("path", { d: "M.202.226a.56.56 0 0 1 .814 0l2.412 2.558a.85.85 0 0 1 0 1.166L1.016 6.51a.56.56 0 1 1-.814-.768L2.344 3.47a.15.15 0 0 0 0-.205L.202.993a.56.56 0 0 1 0-.767z", fill: "#B7B7B7", stroke: "#B7B7B7", strokeWidth: ".1" })
  );
});